
import { Typography, Breadcrumbs, Link } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./styles/breadcrumb.css"
import { useNavigate } from 'react-router-dom';


const Breadcrumb = ({ items }) => {
      const navigate = useNavigate();
  return(
      <Breadcrumbs
        separator={<ChevronRightIcon  className="arrow-icon"/>}
        sx={{ alignItems: "center" }}
        aria-label="breadcrumb"
      >
        {items
          ? items.map((item) => (
              <div key={item.title}>
                {item.to ? (
                   <Link
                    onClick={() => navigate(item.to)} 
                    underline="hover"
                    className="link-navigator"
                  >
                    <span className="text-[13px]">{item.title}</span>
                  </Link>
                ) : (
                  <div className="font-[600] text-[13px] text-[var(--primary-text-color)]">{item.title}</div>
                )}
              </div>
            ))
          : ""}
      </Breadcrumbs>
);
}

export default Breadcrumb;